"use client";

import {NeoModal} from "@/components/@modal/neo.modal";
import {bookingService} from "@/service/booking.service";
import {TripRatingItem} from "@/types/booking";
import {NextPage} from "next";
import {useEffect, useMemo, useState} from "react";
import {TripRatingCard} from "./tripRating.shared";

export const TripRatingPage: NextPage<{
  hasDateFilterChanged: boolean;
  searchValue: string;
  filterRequest: {
    from: number | null;
    to: number | null;
  };
}> = ({hasDateFilterChanged, searchValue, filterRequest}) => {
  const [trips, setTrips] = useState<TripRatingItem[]>([]);
  const [selectedTrip, setSelectedTrip] = useState<TripRatingItem | null>(null);

  useEffect(() => {
    const fetchTripRatings = async () => {
      const response = await bookingService.tripRating(undefined, {
        from: filterRequest.from,
        to: filterRequest.to
      });
      setTrips(response.rows ?? []);
    };

    void fetchTripRatings();
  }, [filterRequest.from, filterRequest.to]);

  const filteredTrips = useMemo(() => {
    const normalizedQuery = searchValue.trim().toLowerCase();

    return trips.filter(
      trip =>
        !normalizedQuery ||
        [trip.name, trip.vehicleName, trip.routeName, trip.description]
          .filter(Boolean)
          .some(value => value.toLowerCase().includes(normalizedQuery))
    );
  }, [searchValue, trips]);

  return (
    <div className="flex min-h-[calc(100vh-63px)] w-full flex-col px-5 py-5">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
        {filteredTrips.map(trip => (
          <TripRatingCard
            key={trip.id}
            trip={trip}
            onViewDetail={setSelectedTrip}
          />
        ))}
      </div>

      <NeoModal
        actionType="tripRatingDetailView"
        onOpen={Boolean(selectedTrip)}
        onClose={() => setSelectedTrip(null)}
        hasActions={false}
        data={{trip: selectedTrip}}
      />
    </div>
  );
};
